export default class HowtoManager {
    constructor() {
      this.trigger = document.querySelectorAll('.c-modal-btn, .c-modal-bg');
    }
    init(){

        Array.from(this.trigger,  e => {
          e.addEventListener('click', function() {
            Array.from(document.querySelectorAll('.youtube-iframe'),  ee => {
              ee.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
            });
          }, false);
        });

        let _this = this;

        let swiper = new Swiper('.swiper-container', {
          pagination: {
            el: '.swiper-pagination',
          },
          navigation: {
            nextEl: '.swiper-btn-next',
            prevEl: '.swiper-btn-prev',
          },
          calculateHeight:true,
        });





    }
}
